/*
 * @Author: chi.yong chi.yong@jitai.ai
 * @Date: 2024-06-08 18:26:17
 * @LastEditors: chi.yong chi.yong@jitai.ai
 * @LastEditTime: 2025-01-17 17:36:38
 * @FilePath: /JTFE_home_user/src/utils/chartStyle.ts
 * @Description: 常用颜色
 *
 * Copyright (c) 2024 by ${git_name_email}, All Rights Reserved.
 */

// 注意：不可删除按index取色的数组元素，只能添加

// logo 色系
/* 
说明：前7个是logo color 后面是扩充色
用法：按index取颜色
*/
export const logoColors = [
  '#326CB2',
  '#C42953',
  '#F8DA49',
  '#861C7F',
  '#E69C37',
  '#49A099',
  '#29c24d',
  '#1F77B4',
  '#FF7F0E',
  '#2CA02C',
  '#D62728',
  '#9467BD',
  '#8C564B',
  '#E377C2',
  '#7F7F7F',
  '#BCBD22',
  '#17BECF',
  '#AEC7E8',
  '#FFBB78',
  '#98DF8A',
  '#CE206F',
  '#3b7ece',
  '#214a7b',
  '#29c24d',
  '#1c8835'
];
// 预测评分 色系
export const kpiColors = ['#2caffe', '#544fc5', '#00e272'];
// export const kpiFiveColors = ['#29c24d', '#F8DA49', '#326CB2', '#FF7F0E', '#C42953'];
export const kpiFiveColors = ['#29c24d', '#b6d24a', '#f8cb49', '#FF7F0E', '#C42953'];
// tree map 色系
export const colorsMap = {
  red: '#f02f3c',
  green: '#0a8e46',
  blue: '#1d3c8e',
  orange: '#E69C37',
  yellow: '#f0ca2f',
  lightBlue: '#1976D2',
  gray: '#7F7F7F'
};
// corelation rank
export const gradientColors = ['#8e1d25', '#f02f3c', '#f67175', '#065b2f', '#0a8e46', '#3ab574'];
// export const gradientColors = [
//   '#B22234',
//   '#D33F49',
//   '#FF4C4C',
//   '#388E3C',
//   '#4CAF50',
//   '#81C784',
//   '#1976D2',
//   '#1E88E5',
//   '#64B5F6',
//   '#1d3c8e',
//   '#2f54f0',
//   '#7190f6',
//   '#8e7b1d',
//   '#f0ca2f',
//   '#f6e771',
// ];
export const echartStyle = {
  copyright: {
    text: '极态科技', // 版权说明
    bottom: '5%', // 距离底部的距离
    right: '15px',
    textStyle: {
      fontSize: 9, // 字体大小
      color: 'rgba(153,153,153)', // 字体颜色
      align: 'right', // 右对齐
      fontWeight: 'normal'
    }
  }
};
